import cn from 'classnames';
import DOMPurify from 'dompurify';
import { HTMLProps, useEffect, useRef } from 'react';

import styles from './Icon.module.css';
import { IconFallback, useIconImg } from './useIconImg';

export type IconCollection =
  | 'exchange'
  | 'ui'
  | 'currency'
  | 'language'
  | 'wallet';

export type IconProps = {
  className?: string;
  icon: string;
  collection?: IconCollection;
  // Only for currency and exchange collections
  type?: 'theme' | 'color' | 'white' | 'dark';
  onClick?: () => void;
  iconFallback?: IconFallback;
} & HTMLProps<Element>;

const DOMPurifyConfig = {
  ALLOWED_TAGS: ['svg', 'img'],
  KEEP_CONTENT: false,
  USE_PROFILES: { svg: true, svgFilters: true, img: true },
  RETURN_DOM_FRAGMENT: true,
};

export function Icon({
  title,
  className,
  icon,
  collection = 'ui',
  type = 'theme',
  onClick,
  iconFallback,
}: IconProps): JSX.Element {
  const actualIcon = collection === 'currency' ? icon.toLowerCase() : icon;
  const preparedFallback = iconFallback
    ? { ...iconFallback, icon: iconFallback.icon.toLowerCase() }
    : undefined;
  const iconImg = useIconImg(collection, actualIcon, preparedFallback) ?? '';
  // const cleanImg = DOMPurify.sanitize(iconImg, DOMPurifyConfig);
  // const ref = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (typeof cleanImg === 'string') {
  //     return;
  //   }

  //   ref?.current?.replaceChildren(cleanImg);
  // }, [cleanImg]);

  return (
    <div
      title={title}
      className={cn(styles.root, styles[collection], styles[type], className)}
      onClick={(): void => {
        if (onClick) onClick();
      }}
    >
      {/* <div ref={ref} /> */}
      {iconImg !== undefined && (
        <div dangerouslySetInnerHTML={{ __html: iconImg || '' }} />
      )}
    </div>
  );
}
